import { NgModule } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  LayoutDefaultWithNamedOutletsComponent
} from 'features/common/components/layout-default-with-named-outlets/layout-default-with-named-outlets.component';

@NgModule({
  providers: [
    provideRouter([
      {
        path: 'flashpay',
        component: LayoutDefaultWithNamedOutletsComponent,
        data: {
          pageClass: 'feature-flash'
        },
        children: [
          {
            path: '',
            loadComponent: () => import('features/flashpay/components/header/header.component').then((x) => x.HeaderComponent),
            outlet: 'header'
          },
          {
            path: '',
            loadComponent: () => import('features/common/components/footer/footer.component').then((x) => x.FooterComponent),
            outlet: 'footer'
          },
          {
            path: '',
            children: [
              {
                path: '',
                loadComponent: () => import('./pages/flashpay/flashpay.component'),
              },
              {
                path: 'success',
                loadComponent: () => import('./pages/success/success.component'),
              }
            ]
          },

        ]
      },
    ], withComponentInputBinding()),
  ]
})
export class FlashpayRoutingModule { }
